import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import { IUsername } from '@/interface/SecretPassword';

import {
  BASE_URL,
  FETCH_UPDATE_COMMISSION_LOG,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'updatecommissionlog' })
export default class UpdateCommissionLog extends VuexModule {
  @Action
  FetchCommissionLog(username: IUsername) {
    return Vue.axios({
      url: BASE_URL + FETCH_UPDATE_COMMISSION_LOG,
      data: username,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }
}
